// Dark Mode Icons
import DarkApplicationIcon from "./dark/Application.svg";
import DarkContactSupportIcon from "./dark/Contact Support.svg";
import DarkDashboardIcon from "./dark/Dashboard.svg";
import DarkEventAlarmConfigIcon from "./dark/Event Alarm Config.svg";
import DarkLogsIcon from "./dark/Logs.svg";
import DarkMasterIcon from "./dark/Master.svg";
import DarkMeterScheduleIcon from "./dark/Meter Scedule.svg";
import DarkMeterIcon from "./dark/Meter.svg";
import DarkNem12Icon from "./dark/NEM12.svg";
import DarkReportIcon from "./dark/report.svg";
import DarkSupersetIcon from "./dark/Superset.svg";
import DarkValidationSummaryIcon from "./dark/Validation Summery.svg";
import DarkValidationIcon from "./dark/Validation.svg";
import DarkFilterIcon from "./dark/filter.svg";

// Application & Sidebar Icons (Light)
import ApplicationIcon from "./application.svg";
import ContactSupportIcon from "./Contact Support.svg";
import DashboardIcon from "./dashboard.svg";
import EventAlarmConfigIcon from "./Event Alarm Config.svg";
import LogsIcon from "./logs.svg";
import MasterIcon from "./master.svg";
import MeterScheduleIcon from "./Meter Scedule.svg";
import MeterIcon from "./meter.svg";
import Nem12Icon from "./NEM12.svg";
import ReportIcon from "./report.svg";
import ReportsIcon from "./reports.svg";
import SupersetIcon from "./superset.svg";
import ValidationSummaryIcon from "./Validation Summery.svg";
import ValidationIcon from "./validation.svg";

// Action Icons
import ActionDeleteIcon from "./action-delete.svg";
import ActionEditIcon from "./action-edit.svg";
import CopyIcon from "./copy.svg";
import DragIcon from "./drag.svg";
import EditIcon from "./edit.svg";
import EditPencilIcon from "./edit-icon.svg";
import EyeIcon from "./eye.svg";
import FolderShareIcon from "./folder-share.svg";
import MoreIcon from "./more.svg";
import MoreIconAlt from "./more-icon.svg";
import PlusIcon from "./plus.svg";
import PlusIconAlt from "./plus-icon.svg";
import RecycleIcon from "./recycle.svg";
import SearchIcon from "./search.svg";
import SettingIcon from "./setting.svg";
import TrashIcon from "./trash-icon.svg";
import UploadIcon from "./upload-icon.svg";
import ActiveIcon from "./active.svg";
import DownloadIcon from "./download.svg";
import FilterIcon from "./filter.svg";
import BulbIcon from "@assets/images/bulb.svg";
import UpArrowIcon from "@assets/images/up-arrow.svg";
import ScrollIcon from "@assets/images/scroll.svg";
import CollapsIcon from "@assets/images/Collaps.svg";
import CorrectIcon from "@assets/images/Correct.svg";
import ExpandIcon from "@assets/images/Expand.svg";
import IOTRawDataIcon from "@assets/images/IOT Raw Data.svg";
import MarkAsFinalResendIcon from "@assets/images/Mark as Final & Resend.svg";
import MarkAsFinalIcon from "@assets/images/Mark As Final.svg";
import MeterStatusIcon from "@assets/images/Meter Status.svg";
import RealTimeDataIcon from "@assets/images/Real time data.svg";
import SyncIcon from "@assets/images/sync.svg";

// UI Elements (Arrows, Chevrons, etc.)
import ArrowLeftIcon from "./arrow-left.svg";
import ArrowRightIcon from "./arrow-right.svg";
import ArrowUpIcon from "./arrow-up.svg";
import AscendingArrowIcon from "./ascending-arrow.svg";
import BothArrowIcon from "./both-arrow.svg";
import ChevronDownIcon from "./chevron-down.svg";
import ChevronRightIcon from "./chevron-right.svg";
import ComboArrowIcon from "./combo-arrow.svg";
import DescendingArrowIcon from "./descending-arrow.svg";
import FilterArrowDownIcon from "./filter-arrow-down.svg";
import FilterArrowUpIcon from "./filter-arrow-up.svg";
import FormChevronDownIcon from "./form-chevron-down-icon.svg";
import RightArrowIcon from "./right-arrow.svg";
import MinusIcon from "./minus-icon.svg";
import SortUpIcon from "./sort-up.svg";
import SortDownIcon from "./sort-down.svg";
import SortIcon from "./sort.svg";
import NotFoundIcon from "./plug.svg";
import AddIcon from "./add.svg";
import DataStatusIcon from "./data-status.svg";
import BatteryNoChargeIcon from "./battery-no-charge.svg";
import BatteryOffline25Icon from "./battery-offline-25.svg";
import BatteryOffline50Icon from "./battery-offline-50.svg";
import BatteryOffline75Icon from "./battery-offline-75.svg";
import BatteryOffline100Icon from "./battery-offline-100.svg";
import BatteryOnline25Icon from "./battery-online-25.svg";
import BatteryOnline50Icon from "./battery-online-50.svg";
import BatteryOnline75Icon from "./battery-online-75.svg";
import BatteryOnline100Icon from "./battery-online-100.svg";
import CloseEyeIcon from "./close-eye.svg";
import DataStatusPreviewSubstitutedDataIcon from "./data-status-preview-substituted-data.svg";
import DeviceStatusOfflineIcon from "./device-status-offline.svg";
import DeviceStatusOnlineIcon from "./device-status-online.svg";
import DeviceStatusIcon from "./device-status.svg";
import FullScreenIcon from "./full-screen.svg";
import ImportMetersIcon from "./import-meters.svg";
import MeterStatusActiveIcon from "./meter-status-active.svg";
import MeterStatusInactiveIcon from "./meter-status-inactive.svg";
import MoveToAdminSelectedCpIcon from "./move-to-admin-selected-cp.svg";
import MoveToSelectedCpIcon from "./move-to-selected-cp.svg";
import NoSignalIcon from "./no-signal.svg";
import SignalOffline50Icon from "./signal-offline-50.svg";
import SignalOffline75Icon from "./signal-offline-75.svg";
import SignalOffline100Icon from "./signal-offline-100.svg";
import SignalOnline50Icon from "./signal-online-50.svg";
import SignalOnline75Icon from "./signal-online-75.svg";
import SignalOnline100Icon from "./signal-online-100.svg";
import DurationIcon from "./duration.svg";
import PublishIcon from "./publish.svg";
import AddTagIcon from "./add-tag.svg";
import RemoveTagIcon from "./remove-tag.svg";

// Status & Indicators
import ActiveInactiveIcon from "./active-inactive.svg";
import CheckMarkIcon from "./check-mark.svg";
import CloseToastIcon from "./close-toast.svg";
import DangerToastIcon from "./danger-toast.svg";
import DeleteModalIcon from "./delete-modal.svg";
import DeleteToastIcon from "./delete-toast.svg";
import FileErrorIcon from "./file-error.svg";
import InactiveIcon from "./inactive.svg";
import InfoIcon from "./info-icon.svg";
import Info from "./info.svg";
import WarningIcon from "./warning.svg";
import OfficialIcon from "./Official Doc.svg";
import PageLoaderIcon from "./page-loader.svg";
import RejectedIcon from "./rejected.svg";
import SuccessIcon from "./success-icon.svg";
import SaveIcon from "./save-icon.svg";
import SaveFinishIcon from "./save-finish-icon.svg";
import ErrorIcon from "./error.svg";

// Header Icons
import AuthShieldIcon from "./auth-shield-icon.svg";
import HeaderBellInitialIcon from "./header-bell-initial-icon.svg";
import HeaderDarkModeIcon from "./header-dark-mode-icon.svg";
import HeaderExpandIcon from "./header-expand-icon.svg";
import HeaderPfpIcon from "./header-pfp-icon.png";
import HeaderVerifiedIcon from "./header-verified-icon.svg";
import LogOutIcon from "./log-out-icon.svg";
import PersonIcon from "./person-icon.svg";
import SunIcon from "./sun.svg";
import ThumbsUpIcon from "./thumbs-up-icon.svg";

// Domain Specific Icons
import BatteryIcon from "./battery.svg";
import BoltIcon from "./bolt.svg";
import BuildingIcon from "./building.svg";
import CalculatorIcon from "./calculator.svg";
import CalendarIcon from "./calendar.svg";
import ColdWaterIcon from "./cold-water.svg";
import ContactSupportSmallIcon from "./contact-support.svg";
import CrossIcon from "./cross.svg";
import DashReportIcon from "./dash-report.svg";
import ExitIcon from "./exit.svg";
import HalfWindowIcon from "./half-window.svg";
import HotWaterIcon from "./hot-water.svg";
import MeterScheduleSmallIcon from "./meter-schedule.svg";
import OtecIcon from "./otec.svg";
import SpeedometerIcon from "./speedometer.svg";
import ValidationSummarySmallIcon from "./validation-summary.svg";
import ValveIcon from "./valve.svg";
import MarkAsSiteContactIcon from "./mark-as-site-contact.svg";
import RiseIcon from "./Rise.svg";
import FallIcon from "./Fall.svg";

// Logos
import DarkLogoPng from "./dark-logo.png";
import DarkSiteLogoIcon from "./dark-site-logo.svg";
import FaviconPng from "./favicon.png";
import LightLogoPng from "./light-logo.png";
import SiteLogoIcon from "./site-logo.svg";
import AuthBackground from "./auth-background.jpg";

//Summary Cards
import DatabaseIcon from "./database.svg";
import OfflineMeterIcon from "./offline-meters.svg";
import ZeroUsagesIcon from "./zero-usages.svg";
import ZeroValueIcon from "./zero-value.svg";
import CumulativeValueIcon from "./cumulative-value-error.svg";
import SpikeIcon from "./spike.svg";
import MaxThresholdIcon from "./max-threshold.svg";
import MinThresholdIcon from "./min-threshold.svg";
import WaterLeakIcon from "./water-leak.svg";
import BarChartIcon from "./bar-chart.svg";
import PastMaximumIcon from "./past-maximun.svg";
import OutOfHoursIcon from "./out-of-hours.svg";
import AvgBenchmarkingIcon from "./avg-benchmarking.svg";
import BenchmarkingIcon from "./benchmarking.svg";
import CheckIcon from "./check.svg";
import ChevronUpIcon from "./chevron-up.svg";
import ExportIcon from "./export.svg";
import FolderIcon from "./folder.svg";
import HeartbeatIcon from "./heartbeat.svg";
import MaxBenchmarkingIcon from "./max-benchmarking.svg";
import MeterSearchIcon from "./meter-search.svg";
import MinBenchmarkingIcon from "./min-benchmarking.svg";
import MinusIconAlt from "./minus.svg";
import NodesIcon from "./nodes.svg";
import OfficeIcon from "./office.svg";
import OfflineIcon from "./offline.svg";
import PinSpeedometerIcon from "./pin-speedometer.svg";
import PowerIcon from "./power.svg";
import PriceTagIcon from "./price-tag.svg";
import RefreshIcon from "./refresh.svg";
import SkillsIcon from "./skills.svg";
import StructureIcon from "./structure.svg";
import EventInfo from "./Event Info.svg";
import TestConnection from "./Test COnnection.svg";
import GeneratorIcon from "./generate.svg";

export const Icons = {
  // Dark Mode
  darkContactSupportIcon: DarkContactSupportIcon,
  darkLogsIcon: DarkLogsIcon,
  darkMeterIcon: DarkMeterIcon,
  darkReportIcon: DarkReportIcon,
  darkSupersetIcon: DarkSupersetIcon,
  darkValidationSummaryIcon: DarkValidationSummaryIcon,
  darkFilterIcon: DarkFilterIcon,

  // App & Sidebar (Light)
  contactSupportIcon: ContactSupportIcon,
  logsIcon: LogsIcon,
  meterIcon: MeterIcon,
  reportIcon: ReportIcon,
  reportsIcon: ReportsIcon,
  supersetIcon: SupersetIcon,
  validationSummaryIcon: ValidationSummaryIcon,

  // Actions
  actionDeleteIcon: ActionDeleteIcon,
  actionEditIcon: ActionEditIcon,
  copyIcon: CopyIcon,
  dragIcon: DragIcon,
  editIcon: EditIcon,
  editPencilIcon: EditPencilIcon,
  eyeIcon: EyeIcon,
  folderShareIcon: FolderShareIcon,
  moreIcon: MoreIcon,
  moreIconAlt: MoreIconAlt,
  plusIcon: PlusIcon,
  plusIconAlt: PlusIconAlt,
  recycleIcon: RecycleIcon,
  searchIcon: SearchIcon,
  settingIcon: SettingIcon,
  trashIcon: TrashIcon,
  uploadIcon: UploadIcon,
  activeIcon: ActiveIcon,
  downloadIcon: DownloadIcon,
  filterIcon: FilterIcon,
  bulbIcon: BulbIcon,
  upArrowIcon: UpArrowIcon,
  scrollIcon: ScrollIcon,
  collapsIcon: CollapsIcon,
  correctIcon: CorrectIcon,
  expandIcon: ExpandIcon,
  iotRawDataIcon: IOTRawDataIcon,
  markAsFinalResendIcon: MarkAsFinalResendIcon,
  markAsFinalIcon: MarkAsFinalIcon,
  meterStatusIcon: MeterStatusIcon,
  realTimeDataIcon: RealTimeDataIcon,
  syncIcon: SyncIcon,
  generatorIcon: GeneratorIcon,

  // UI Elements
  arrowLeftIcon: ArrowLeftIcon,
  arrowRightIcon: ArrowRightIcon,
  arrowUpIcon: ArrowUpIcon,
  ascendingArrowIcon: AscendingArrowIcon,
  bothArrowIcon: BothArrowIcon,
  chevronDownIcon: ChevronDownIcon,
  chevronRightIcon: ChevronRightIcon,
  comboArrowIcon: ComboArrowIcon,
  descendingArrowIcon: DescendingArrowIcon,
  filterArrowDownIcon: FilterArrowDownIcon,
  filterArrowUpIcon: FilterArrowUpIcon,
  formChevronDownIcon: FormChevronDownIcon,
  rightArrowIcon: RightArrowIcon,
  minusIcon: MinusIcon,
  saveIcon: SaveIcon,
  saveFinishIcon: SaveFinishIcon,
  sortUpIcon: SortUpIcon,
  sortDownIcon: SortDownIcon,
  sortIcon: SortIcon,
  notFoundIcon: NotFoundIcon,
  addIcon: AddIcon,
  dataStatusIcon: DataStatusIcon,
  batteryNoChargeIcon: BatteryNoChargeIcon,
  batteryOffline25Icon: BatteryOffline25Icon,
  batteryOffline50Icon: BatteryOffline50Icon,
  batteryOffline75Icon: BatteryOffline75Icon,
  batteryOffline100Icon: BatteryOffline100Icon,
  batteryOnline25Icon: BatteryOnline25Icon,
  batteryOnline50Icon: BatteryOnline50Icon,
  batteryOnline75Icon: BatteryOnline75Icon,
  batteryOnline100Icon: BatteryOnline100Icon,
  closeEyeIcon: CloseEyeIcon,
  dataStatusPreviewSubstitutedDataIcon: DataStatusPreviewSubstitutedDataIcon,
  deviceStatusOfflineIcon: DeviceStatusOfflineIcon,
  deviceStatusOnlineIcon: DeviceStatusOnlineIcon,
  deviceStatusIcon: DeviceStatusIcon,
  fullScreenIcon: FullScreenIcon,
  importMetersIcon: ImportMetersIcon,
  meterStatusActiveIcon: MeterStatusActiveIcon,
  meterStatusInactiveIcon: MeterStatusInactiveIcon,
  moveToAdminSelectedCpIcon: MoveToAdminSelectedCpIcon,
  moveToSelectedCpIcon: MoveToSelectedCpIcon,
  noSignalIcon: NoSignalIcon,
  signalOffline50Icon: SignalOffline50Icon,
  signalOffline75Icon: SignalOffline75Icon,
  signalOffline100Icon: SignalOffline100Icon,
  signalOnline50Icon: SignalOnline50Icon,
  signalOnline75Icon: SignalOnline75Icon,
  signalOnline100Icon: SignalOnline100Icon,
  durationIcon: DurationIcon,
  publishIcon: PublishIcon,
  addTagIcon: AddTagIcon,
  removeTagIcon: RemoveTagIcon,

  // Status & Indicators
  activeInactiveIcon: ActiveInactiveIcon,
  checkMarkIcon: CheckMarkIcon,
  closeToastIcon: CloseToastIcon,
  dangerToastIcon: DangerToastIcon,
  deleteModalIcon: DeleteModalIcon,
  deleteToastIcon: DeleteToastIcon,
  fileErrorIcon: FileErrorIcon,
  inactiveIcon: InactiveIcon,
  infoIcon: InfoIcon,
  info: Info,
  warningIcon: WarningIcon,
  officialIcon: OfficialIcon,
  pageLoaderIcon: PageLoaderIcon,
  rejectedIcon: RejectedIcon,
  successIcon: SuccessIcon,
  errorIcon: ErrorIcon,

  // Header
  authShieldIcon: AuthShieldIcon,
  headerBellInitialIcon: HeaderBellInitialIcon,
  headerDarkModeIcon: HeaderDarkModeIcon,
  headerExpandIcon: HeaderExpandIcon,
  headerPfpIcon: HeaderPfpIcon,
  headerVerifiedIcon: HeaderVerifiedIcon,
  logOutIcon: LogOutIcon,
  personIcon: PersonIcon,
  sunIcon: SunIcon,
  thumbsUpIcon: ThumbsUpIcon,

  // Domain Specific
  batteryIcon: BatteryIcon,
  boltIcon: BoltIcon,
  buildingIcon: BuildingIcon,
  calculatorIcon: CalculatorIcon,
  calendarIcon: CalendarIcon,
  coldWaterIcon: ColdWaterIcon,
  contactSupportSmallIcon: ContactSupportSmallIcon,
  crossIcon: CrossIcon,
  dashReportIcon: DashReportIcon,
  exitIcon: ExitIcon,
  halfWindowIcon: HalfWindowIcon,
  hotWaterIcon: HotWaterIcon,
  meterScheduleSmallIcon: MeterScheduleSmallIcon,
  otecIcon: OtecIcon,
  speedometerIcon: SpeedometerIcon,
  validationSummarySmallIcon: ValidationSummarySmallIcon,
  valveIcon: ValveIcon,
  markAsSiteContactIcon: MarkAsSiteContactIcon,
  riseIcon: RiseIcon,
  fallIcon: FallIcon,

  // Logos
  darkLogoPng: DarkLogoPng,
  darkSiteLogoIcon: DarkSiteLogoIcon,
  faviconPng: FaviconPng,
  lightLogoPng: LightLogoPng,
  siteLogoIcon: SiteLogoIcon,
  authBackground: AuthBackground,

  // Summary Cards
  databaseIcon: DatabaseIcon,
  offlineMeterIcon: OfflineMeterIcon,
  zeroUsagesIcon: ZeroUsagesIcon,
  zeroValueIcon: ZeroValueIcon,
  cumulativeValueIcon: CumulativeValueIcon,
  spikeIcon: SpikeIcon,
  maxThresholdIcon: MaxThresholdIcon,
  minThresholdIcon: MinThresholdIcon,
  waterLeakIcon: WaterLeakIcon,
  barChartIcon: BarChartIcon,
  pastMaximumIcon: PastMaximumIcon,
  outOfHoursIcon: OutOfHoursIcon,

  avgBenchmarkingIcon: AvgBenchmarkingIcon,
  benchmarkingIcon: BenchmarkingIcon,
  checkIcon: CheckIcon,
  chevronUpIcon: ChevronUpIcon,
  exportIcon: ExportIcon,
  folderIcon: FolderIcon,
  heartbeatIcon: HeartbeatIcon,
  maxBenchmarkingIcon: MaxBenchmarkingIcon,
  meterSearchIcon: MeterSearchIcon,
  minBenchmarkingIcon: MinBenchmarkingIcon,
  minusIconAlt: MinusIconAlt,
  nodesIcon: NodesIcon,
  officeIcon: OfficeIcon,
  offlineIcon: OfflineIcon,
  pinSpeedometerIcon: PinSpeedometerIcon,
  powerIcon: PowerIcon,
  priceTagIcon: PriceTagIcon,
  refreshIcon: RefreshIcon,
  skillsIcon: SkillsIcon,
  structureIcon: StructureIcon,
  eventInfo: EventInfo,
  testConnection: TestConnection,
};

export const SidebarIcons = {
  light: {
    dashboard: DashboardIcon,
    management: MasterIcon,
    reportingSetup: ReportIcon,
    reporting: ValidationIcon,
    monitoring: MeterScheduleIcon,
    dataTools: Nem12Icon,
    provisioning: MeterIcon,
    alarmsSetup: EventAlarmConfigIcon,
    integrations: MasterIcon,
    logs: LogsIcon,
    system: ApplicationIcon,
  },
  dark: {
    dashboard: DarkDashboardIcon,
    management: DarkMasterIcon,
    reportingSetup: DarkReportIcon,
    reporting: DarkValidationIcon,
    monitoring: DarkMeterScheduleIcon,
    dataTools: DarkNem12Icon,
    provisioning: DarkMeterIcon,
    alarmsSetup: DarkEventAlarmConfigIcon,
    integrations: DarkMasterIcon,
    logs: DarkLogsIcon,
    system: DarkApplicationIcon,
  },
};
